import { useLanDirectUrl } from '../hooks/useLanDirectUrl';

/**
 * Drop-in <img> that resolves an in-app storage path (e.g. `/api/shizai/receipts/photo/xxx`)
 * to a LAN-direct URL when the browser has probed reachability of the NAS agent.
 * Falls back to the standard backend proxy URL silently.
 *
 * Usage:
 *   <StorageThumb path={line.photo_url} alt="" className="w-7 h-7 rounded object-cover" />
 *
 * `path` should be a RELATIVE path starting with `/api/…`. Absolute http URLs
 * are passed through untouched.
 */
export function StorageThumb({ path, alt = '', ...imgProps }) {
  const src = useLanDirectUrl(path);
  return <img src={src} alt={alt} {...imgProps} />;
}

/**
 * Drop-in <a> that opens a storage file, using the LAN-direct URL when
 * available. Behaves identically to a plain anchor otherwise.
 */
export function StorageLink({ path, children, ...anchorProps }) {
  const href = useLanDirectUrl(path);
  return <a href={href} {...anchorProps}>{children}</a>;
}
